import { useTranslation } from "react-i18next";

import Button from "@vfuk/core-button/dist/Button";
import Image from "@vfuk/core-image";
import Spacing from "@vfuk/core-spacing";

import error from "../../assets/images/error.png";
import "../../assets/styles/common.scss";
import {
  StyledButton,
  StyledButtons,
  StyledError,
  StyledErrorModalContent,
} from "./ErrorModalContent.styled";

export type ErrorModalContentProps = {
  heading?: string;
  message: string;
  body: string;
  onClose: () => void;
  onRetry?: () => void;
  closeMessage?: string;
  retryMessage?: string;
  loading?: boolean;
  errorMessage?: string;
  failedUser?: Array<{
    message: string;
    email: string;
  }>;
};

export const ErrorModalContent = (
  props: ErrorModalContentProps
): JSX.Element => {
  const { t } = useTranslation();

  return (
    <StyledErrorModalContent role="dialog">
      <StyledError>
        <Image
          alt={t("shared:users:alt_message")}
          sm={{
            src: error,
          }}
        />
      </StyledError>
      <div className="modalHeading">{props.heading}</div>
      <Spacing spacingLevel={{ top: 4, left: 7, right: 7 }}>
        <div className="modalMessage">{props.message}</div>
      </Spacing>
      <Spacing spacingLevel={{ top: 3 }}>
        <div className="modalSubmessage">{props.body}</div>
      </Spacing>
      <br />
      <StyledButtons>
        <StyledButton>
          <Button
            width="auto"
            appearance="primary"
            text={props.closeMessage || "Close"}
            onClick={props.onClose}
          />
        </StyledButton>
      </StyledButtons>
    </StyledErrorModalContent>
  );
};
